export default __webpack_public_path__ + "static/media/visibility-on-icon.7c3d8d5c.svg";